import { Outlet } from 'react-router-dom';
import withNotLogged from '../hocs/withNotLogged';
import Sidebar from '../components/Sidebar';

const LayoutWithSidebar = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="profile">
                    <Sidebar />
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default withNotLogged(LayoutWithSidebar);
